export const HISTORY_ITEM_TYPE = {
	DETAILS: "DETAILS",
	PILOT: "PILOT",
	THEME: "THEME",
	DEADLINE: "DEADLINE",
	RISK: "RISK",
	FREQUENCY: "FREQUENCY",
	PRIORITY: "PRIORITY",
	STATUS: "STATUS",
	CREATED: "CREATED",
	FIELD_EDITED: "FIELD_EDITED",
	CONTENT_ADDED: "CONTENT_ADDED",
	CONTENT_REMOVED: "CONTENT_REMOVED",
	COMMENT: "COMMENT",
	COMMENT_MODIFIED: "COMMENT_MODIFIED",
	COMMENT_REMOVED: "COMMENT_REMOVED",
	DELETED: "DELETED",
	BULK_DELETED: "BULK_DELETED",
};

export const HISTORY_EVENT_TYPE = {
	COMMITMENT_CREATED: "COMMITMENT_CREATED",
	FIELD_EDITED: "FIELD_EDITED",
	COMMITMENT_SOURCE_ADDED: "COMMITMENT_SOURCE_ADDED",
	COMMITMENT_SOURCE_REMOVED: "COMMITMENT_SOURCE_REMOVED",
	COMMITMENT_COMMENT_ADDED: "COMMITMENT_COMMENT_ADDED",
	COMMITMENT_COMMENT_MODIFIED: "COMMITMENT_COMMENT_MODIFIED",
	COMMITMENT_COMMENT_REMOVED: "COMMITMENT_COMMENT_REMOVED",
};
